/* oxlint-disable import/no-unassigned-import -- LINTER migration follow up */
// Sentry initialization should be imported first!
import "./scaffolding/instrument";

declare const window: {
  hideIntro: boolean;
  addEventListener: (v: string, callback: (e: Event) => void) => void;
  innerWidth: number;
};

/**
 *  This checks when Playwright is running
 *  React-scan breaks the playwright preview window (which makes debugging really hard)
 * */
const isAutomatedBrowser = navigator.webdriver;

if (isLocal() && !isAutomatedBrowser) {
  /**
   * hideIntro is a hack to hide the marketing intro from react-scan
   * https://github.com/aidenybai/react-scan/blob/main/packages/scan/src/web/utils/log.ts#L86
   */
  window.hideIntro = true;
  // Must be imported before React and React DOM
  const ReactScan = await import("react-scan").then((m) => m.scan);
  ReactScan({ enabled: false, showToolbar: true });
  window.hideIntro = true;
}

import { handleVitePreloadError } from "./features/app-update/app-update";

window.addEventListener("vite:preloadError", handleVitePreloadError);

// Other imports

import { isLocal } from "@grafit/shared/utils/envs.front";
import React from "react";
import { createRoot } from "react-dom/client";
import { setupCustomFavicon } from "./scaffolding/favicon-custom";
import { Providers } from "./scaffolding/providers";
import type { router } from "./scaffolding/router";
import { registerServiceWorker } from "./service-worker/register-service-worker";
import "./utils/adapt-window-root-size.ts";
import "@grafit/i18n";

import "./index.css";

setupCustomFavicon();
registerServiceWorker();

// TODO check if we really need this declaration here
// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById("root") as HTMLDivElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Providers />
  </React.StrictMode>,
);
